import {anyPass, isEmpty, isUndefined} from '@yandex-delivery/utils'

export const isEmptyOrUndefined: (value?: string) => boolean = anyPass([isUndefined, isEmpty])
